import { LoadingMessages } from '@src/utils/enums';
import { useApp } from '@stores';

export const handleFileProcessing = async <T>(callback: () => Promise<T>): Promise<T> => {
  const { setIsLoading, setIsSavingProgress } = useApp.getState();

  setIsLoading(true, LoadingMessages.Processing);
  setIsSavingProgress(true);

  try {
    return await callback();
  } finally {
    setIsLoading(false);
    setIsSavingProgress(false);
  }
};
